import theme from "@/theme";

export const styles = {
  wrapper: {
    width: "100%",
    maxWidth: "519px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    bgcolor: "#fff",
    padding: "2.5rem 4rem",
    boxShadow: "0px 0px 25px 0px rgba(22, 22, 22, 0.05)",
    borderRadius: "1.5rem",
    gap: "44px",
  },
  inputLabel: {
    fontSize: "1rem",
    lineHeight: "21.33px",
    color: theme.palette.custom.blueGray900,
    position: "absolute",
    left: "-13px !important",
    fontWeight: "500",
  },

  formControlLabelCheckbox: {
    display: "flex",
    alignItems: "center",
    "& .MuiCheckbox-root": {
      padding: 0,
      width: "24px",
      height: "24px",
      color: "transparent",
      "& svg": {
        width: "24px",
        height: "24px",
        borderRadius: "6px",
        border: `2px solid ${theme.palette.custom.blueGray400}`,
        backgroundColor: "#fff",
        boxSizing: "border-box",
      },
      "&.Mui-checked svg": {
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        color: "#fff",
      },
    },
    "& .MuiFormControlLabel-label": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 400,
      fontSize: "15px",
      lineHeight: "150%",
      letterSpacing: "0%",
      color: theme.palette.text.primary,
      marginLeft: "8px",
    },
  },

  formControlLabel: {
    display: "flex",
    gap: "6px",
    margin: 0,
    height: "1.5rem",
    "& .MuiFormControlLabel-label": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 400,
      fontSize: "15px",
      lineHeight: "150%",
      letterSpacing: "0%",
      color: theme.palette.custom.blueGray700,
    },
  },
  button: {
    color: "#FFFFFF",
    py: 1.5,
    height: "50px",
    fontSize: "16px",
    lineHeight: "22px",
    textTransform: "none",
    borderRadius: "28px",
    "&.Mui-disabled": {
      backgroundColor: theme.palette.custom.blueGray400,
      color: "#fff",
      cursor: "not-allowed",
    },
  },
  logoWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "110px",
    opacity: 1,
    gap: "24px",
  },
  logoBox: {
    width: "102px",
    height: "32px",
  },
  titleWrapper: {
    display: "flex",
    flexDirection: "column",
    height: "54px",
    opacity: 1,
    gap: "6px",
  },
  title: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "22px",
    lineHeight: "26px",
    textAlign: "center",
    color: "#000000",
  },
  subtitle: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "22px",
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  errorText: {
    color: theme.palette.error.main,
    mb: 2,
    textAlign: "center",
  },
  Link: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "150%",
    letterSpacing: "0%",
    textDecoration: "underline",
    textDecorationColor: theme.palette.custom.mainBlue,
    textDecorationThickness: "1px",
    textUnderlineOffset: "3px",
    cursor: "pointer",
  },
  noAccountText: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "24px",
    letterSpacing: "0%",
    textAlign: "center",
    color: theme.palette.custom.blueGray700,
  },
};
